<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-md-6 left">
                <h4 class="modal-title" v-html="Lang.get('js.callback_form.title')"></h4>
                <form id="callback-form"
                      action="#"
                      @submit.prevent="">
                    <div class="form-group relative my-input-item">
                        <input type="text"
                               name="name"
                               @click="clearFormErrors('name')"
                               class="form-control my-input-form my-input-form-grey"
                               :placeholder="Lang.get('common.name')"
                               v-model="form.name"
                        >
                        <span class="help is-danger text-danger"
                              v-if="form.errors.has('name')"
                              v-text="form.errors.get('name')">
                        </span>
                    </div>

                    <div class="form-group relative my-input-item">
                        <input type="text"
                               name="phone"
                               @click="clearFormErrors('phone')"
                               class="form-control mobilephone-input-mask my-input-form my-input-form-grey"
                               :placeholder="Lang.get('common.phone')"
                               v-model="form.phone"
                        >
                        <span class="help is-danger text-danger"
                              v-if="form.errors.has('phone')"
                              v-text="form.errors.get('phone')">
                        </span>
                    </div>

                  <input type="text"
                         name="checkBot"
                         v-model="checkBot"
                  >
                    <div class="text-left">
                        <input class="my-button"
                               type="submit"
                               @click="onSubmit"
                               :disabled="isDisabled"
                               :value="Lang.get('common.send')">
                        <widget-loading v-if="form.loading" color="#03a9f4"></widget-loading>
                    </div>

                </form>
            </div>
            <div class="col-12 col-md-6 right">
                <div class="list-block">
                    <ul>
                        <li class="item-services-ask">
                            <p class="text-services-ask">Консультация по трудоустройству</p>
                        </li>
                        <li class="item-services-ask">
                            <p class="text-services-ask">Помощь в выборе товара</p>
                        </li>
                        <li class="item-services-ask">
                            <p class="text-services-ask">Дополнительные материалы для ознакомления</p>
                        </li>
                    </ul>
                </div>

                <div class="block-person d-block d-flex align-items-center">
                    <div class="block-img">
                        <img src="/local-images/author.jpg" :alt="Lang.get('js.name_manager')"/>
                    </div>
                    <div class="description-person">
                        <p class="title-person">{{ Lang.get('js.callback_form.your_manager')}}</p>
                        <p class="name-person">{{ Lang.get('js.callback_form.name_manager')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import WidgetLoading from '../elements/WidgetLoading';

  export default {
    name: "form-call-back",
    components: {
      WidgetLoading,
    },
    data() {
      return {
        form: new Form({
              name: '',
              phone: '',
              type: 'callback',
              url: location,
            },
            true
        ),
        isDisabled: false,
        checkBot: '',
        Lang,
      }
    },
    methods: {
      clearFormErrors(name) {
        this.form.errors.clear(name);
        if (!this.form.errors.any()) {
          this.isDisabled = false;
        }
      },
      onSubmit() {
        let vm = this;
        this.isDisabled = true;

        if(this.checkBot === '') {
          this.form.post('/callback').then(res => {
            vm.isDisabled = false;
            document.querySelector('#callback-form').innerHTML = "<span class='success-sent-text text-white text-center'>" + res +"</span>";
          }).catch(error => console.log(error));
        }


      },
    },
    mounted() {
      helpers.setInputMask('mobilephone');
    }
  }
</script>



// WEBPACK FOOTER //
// resources/js/components/forms/FormCallBack.vue